// Validacao do codigo de barras (GTIN/EAN) que vai no <cEAN> da NF-e/NFC-e.
//
// Dois jeitos de a SEFAZ recusar, com codigos diferentes:
//   - caractere que nao e digito (ponto, letra, espaco no meio) fura o PATTERN do XSD e
//     derruba o lote inteiro com cStat 225 "Falha no Schema XML" — que NAO diz o campo.
//     Caso real (VND-003049, 01/10/2026): produto 665 com EAN `7898917589076.`, recusado
//     duas vezes e a tela mostrando "Emissao nao foi iniciada".
//   - so digitos mas comprimento/digito verificador errado volta cStat 611 "cEAN invalido".
//
// Regra medida contra o historico em 05/10/2026: os 1.149 cEAN distintos de notas
// AUTORIZADAS passam todos aqui (numerico, 8/12/13/14 digitos, DV certo). E o prefixo 2
// ("uso interno" da GS1) NAO e recusado: 1.567 NFC-e autorizadas o carregam — por isso
// esta regra nao o olha.
//
// VAZIO e `SEM GTIN` sao validos: o XML manda `SEM GTIN`, aceito pela SEFAZ (255 NFC-e
// autorizadas assim na mesma medicao).

/** Digito verificador GTIN (pesos 3,1 a partir da direita) dos digitos SEM o DV. */
function digitoVerificador(semDv: string): number {
  let soma = 0;
  for (let i = semDv.length - 1, peso = 3; i >= 0; i--, peso = peso === 3 ? 1 : 3) {
    soma += Number(semDv[i]) * peso;
  }
  return (10 - (soma % 10)) % 10;
}

/** `null` quando o codigo de barras pode ir pra nota; senao a frase pro operador. */
export function motivoEanInvalido(bruto: string | null | undefined): string | null {
  const s = String(bruto ?? '').trim();
  if (s === '' || s.toUpperCase() === 'SEM GTIN') return null;
  if (!/^\d+$/.test(s)) {
    return `codigo de barras "${s}" tem caractere que nao e numero — a SEFAZ so aceita digitos.`;
  }
  if (![8, 12, 13, 14].includes(s.length)) {
    return `codigo de barras "${s}" tem ${s.length} digitos — a SEFAZ aceita 8, 12, 13 ou 14.`;
  }
  const esperado = digitoVerificador(s.slice(0, -1));
  if (esperado !== Number(s.slice(-1))) {
    return `codigo de barras "${s}" tem o ultimo digito errado (deveria ser ${esperado}) — provavelmente foi digitado errado.`;
  }
  return null;
}
